import { render, staticRenderFns } from "./RabiesProofUploader.vue?vue&type=template&id=c8039200&scoped=true&"
import script from "./RabiesProofUploader.vue?vue&type=script&lang=js&"
export * from "./RabiesProofUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8039200",
  null
  
)

export default component.exports